<template>
    <button
      class="floating-button"
      :style="{ left: left + 'px', top: top + 'px' }"
      @mousedown="startDragging"
      @mouseup="stopDragging"
      @mouseleave="stopDragging"
    >
    <svg-icon icon-class="Assistant" className="icon-assistant" @dblclick="openDrawer"/> 
    </button>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isDragging: false,
        initialX: 0,
        initialY: 0,
        left: window.innerWidth - 60, // 初始位置在右下角
        top: window.innerHeight - 100  // 初始位置在右下角
      };
    },
    methods: {
      startDragging(event) {
        this.isDragging = true;
        this.initialX = event.clientX;
        this.initialY = event.clientY;
  
        document.addEventListener('mousemove', this.dragging);
        document.addEventListener('mouseup', this.stopDragging);
      },
      dragging(event) {
        if (!this.isDragging) return;  
        // 限制移动范围
        this.left = Math.max(0, Math.min(window.innerWidth - 56, this.left + event.clientX - this.initialX));
        this.top = Math.max(0, Math.min(window.innerHeight - 56, this.top + event.clientY - this.initialY));
  
        this.initialX = event.clientX;
        this.initialY = event.clientY;
      },
      stopDragging() {
        this.isDragging = false;
        document.removeEventListener('mousemove', this.dragging);
        document.removeEventListener('mouseup', this.stopDragging);
      },
      openDrawer(){
        this.$emit('openDrawer')
      }
    },
    mounted(){
      const that=this
      window.onresize = () => {
        return (() => {
            window.screenWidth = document.body.clientWidth
            window.screenHeight = document.body.clientHeight
            that.left=window.innerWidth - 60, // 初始位置在右下角
            that.top=window.innerHeight - 100  // 初始位置在右下角
        })()
      }
    }
  };
  </script>
  
  <style scoped>
  .floating-button {
    position: fixed;
    z-index: 10000; /* 确保按钮在所有元素之上 */
    background-color:#3084fadc;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    cursor: move;
  }
  .floating-button:hover{
    background-color:#1677ff!important;
  }  
  .floating-button .icon-assistant {
    font-size: 35px;
    cursor: move;
  }
  </style>